import React from "react";
import "../../css/MainPage/MainLanding.css";
import life1 from "../../assets/header-images/life1.jpg";
import preparing from "../../assets/header-images/preparing.jpg";
import essentialtips from "../../assets/header-images/essentialtips.jpg";
import maximizing from "../../assets/header-images/maximizing.jpg";
import gpas from "../../assets/header-images/gpa.jpg";
import steminternsihp from "../../assets/header-images/steminternsihp.jpg";

import resume from "../../assets/header-images/resume.jpg";

const trafficBoxData = [
  {
    partNumber: "1",
    title: "Preparing for College Life",
    description:
      "Guidance on preparing for college during the summer. Learn tips on joining online communities, understanding major requirements, exploring clubs, contacting roommates, and preparing essential items to ensure a smooth transition to college life.",
    image: preparing,
    link: "/college-life/before-college",
  },
  {
    partNumber: "2",
    title: "Essential College Tips",
    description:
      "Get advice on excelling in school, managing time effectively, utilizing academic resources, setting SMART goals, maintaining a good GPA, and planning your schedule. These tips are designed to help you succeed academically and balance your college life.",
    image: essentialtips,
    link: "/college-life/college-tips",
  },
  {
    partNumber: "3",
    title: "Maximizing School Benefits",
    description:
      "Overview of the various benefits and resources available on campus. This includes campus facilities like libraries and sports centers, student services such as academic advising and counseling, health and wellness resources, housing options, diversity and inclusion initiatives, and financial perks available to students.",
    image: maximizing,
    link: "/college-life/school-benefits",
  },
  // {
  //   partNumber: "4",
  //   title: "GPA Calculator",
  //   description:
  //     "A handy tool for calculating your GPA. Includes detailed instructions on how to input your grades and credits to accurately determine your grade point average, helping you stay on top of your academic performance.",
  //   image: gpas,
  //   link: "/tools/gpa-calculator",
  // },
  {
    partNumber: "5",
    title: "STEM Internships Opportunities",
    description:
      "A comprehensive guide to securing internships. This includes a step-by-step checklist, details on the application process, tips for crafting a standout resume and LinkedIn profile, strategies for effective internship searching, the importance of referrals, interview preparation tips, and methods for tracking your applications.",
    image: steminternsihp,
    link: "/college-life/stem-internships",
  },

  {
    partNumber: "6",
    title: "Crafting Your Resume",
    description:
      "Building a strong resume is key to securing internships, scholarships, and jobs. This page offers templates, tips, and action verbs to help you create a standout resume. Highlight your skills and achievements clearly to make a strong first impression.",
    image: resume,
    link: "/college-life/resume",
  },
];

const introText =
  "This page is designed to provide you with comprehensive information and resources to help you navigate your college experience. From preparing for college and excelling in your studies to utilizing campus benefits and securing internships, you'll find valuable insights and tools to support your academic and professional journey. Click on each category to explore detailed information and learn how you can benefit from these resources.";

const CollegeLife = () => {
  return (
    <div className="main-landing-page">
      {/* Hero Section */}
      <div
        className="main-landing-hero"
        style={{ backgroundImage: `url(${life1})` }}
      >
        <div className="main-landing-hero-overlay" />
        <div className="main-landing-hero-content">
          <h1>College Life</h1>
          <div className="main-landing-hero-sub">
            Your guide to thriving in college, on and off campus.
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="main-landing-mission-section">
        <div className="main-landing-mission-container">
          <p>{introText}</p>
        </div>
      </div>

      {/* Main Sections */}
      <div className="main-landing-section">
        <div className="main-landing-section-title">College Life Resources</div>
        <div className="main-landing-grid">
          {trafficBoxData.map((box, idx) => (
            <a key={idx} href={box.link} className="afford-college-card">
              <div className="afford-college-card-image">
                <img src={box.image} alt={box.title} />
              </div>
              <div className="afford-college-card-content">
                <div>
                  <div className="afford-college-card-title">{box.title}</div>
                  <div className="afford-college-card-desc">
                    {box.description}
                  </div>
                </div>
                <div className="afford-college-link-btn">Learn More</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CollegeLife;
